import request from '@/utils/server'
// 食材模板列表
export function getAllProducts(query) {
    return request({
      url: '/inventory/getAllProducts',
      method: 'get',
      params: query
    })
  }
  // 新增
  export function addProducts(data) {
    return request({
      url: '/inventory/addProducts',
      method: 'post',
      data:data
    })
  }
  // 删除
   export function delProducts(data) {
    return request({
      url: '/inventory/delProducts',
      method: 'post',
      data:data
    })
  }
  // 修改

    export function editProducts(data) {
    return request({
      url: '/inventory/editProducts',
      method: 'post',
      data:data
    })
  }